declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    hj: any;
  }
}

export const sendHotjarEvent = (event: string) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  window.hj =
    window.hj ||
    function () {
      // eslint-disable-next-line prefer-rest-params, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      (window.hj.q = window.hj.q || []).push(arguments);
    };
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  window.hj('event', event);
};
